/** Minimum password length (character count) enforced on every create/change path. */
export const PASSWORD_MIN_LENGTH = 8;
/**
 * Maximum password length (character count). Pragmatic ceiling — not byte-exact against
 * bcrypt's 72-byte limit; residual multibyte-truncation risk is accepted.
 */
export const PASSWORD_MAX_LENGTH = 64;
